import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {debounceTime, finalize, switchMap, takeUntil, tap} from 'rxjs/operators';
import {IUser} from 'src/app/users/users';
import {UsersService} from 'src/app/users/users.service';
import {IMetricsWidget} from '../widgets';
import {ReportsService} from '../reports.service';

@Component({
    selector: 'app-metrics-widget',
    templateUrl: './metrics-widget.component.html',
    styleUrls: ['./metrics-widget.component.scss'],
    standalone: false
})
export class MetricsWidgetComponent implements OnInit {

  private destroyed$: Subject<void> = new Subject<void>();
  filteredValues: IUser[] = [];
  isLoading = false;
  widgetData: IMetricsWidget[] = [];
  widgetFormGroup: FormGroup;
  widgetHeaderData = [
    this.translateService.stream(marker('Metrics MTD')),
    this.translateService.stream(marker('My')),
    this.translateService.stream(marker('Team')),
  ];
  private _hasDownLineUsers: boolean;

  constructor(
    private fb: FormBuilder,
    public service: ReportsService,
    public translateService: TranslateService,
    private usersService: UsersService,
  ) {
  }

  ngOnInit() {
    this.widgetFormGroup = this.fb.group({
      user: [''],
    });
    this.retrieveMyMetricsData();

    this.widgetFormGroup
      .get('user')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap(value => this.usersService.filterUsersByUserName(value)
          .pipe(
            finalize(() => this.isLoading = false),
          ),
        ),
      )
      .subscribe(response => {
        this.filteredValues = response.list;
      });
  }

  onUserSelected(user: IUser) {
    if (user === undefined) {
      this.retrieveMyMetricsData();
      return;
    }
    this.retrieveDownLineMetricsData(user.userId);
  }

  metricsExist() : boolean {
    return this.myMetricsExist() || this.teamMetricsExist();
  }

  myMetricsExist(): boolean {
    return this.widgetData.filter(row => row.myGoals !== '').length > 0;
  }
  teamMetricsExist(): boolean {
    return this.widgetData.filter(row => row.teamGoals !== '').length > 0;
  }

  private retrieveDownLineMetricsData(userId: number) {
    this.service.getDownLineMetricsWidget(userId)
    .pipe(takeUntil(this.destroyed$))
    .subscribe(
      (response) => {
        this.widgetData = response;
      },
    );
  }

  private retrieveMyMetricsData() {
    this.service.getMetricsWidget()
    .pipe(takeUntil(this.destroyed$))
    .subscribe(
      (response) => {
        this.widgetData = response;

        if(this.metricsExist()) {
          return this.usersService.downlineUsersExist().subscribe(ret => this._hasDownLineUsers = ret);
        }
      },
    );
  }

  hasDownLineUsers() {
    return this._hasDownLineUsers;
  }
}
